import { render, staticRenderFns } from "./headMeun.vue?vue&type=template&id=4135089a&scoped=true&"
import script from "./headMeun.vue?vue&type=script&lang=js&"
export * from "./headMeun.vue?vue&type=script&lang=js&"
import style0 from "./headMeun.vue?vue&type=style&index=0&id=4135089a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4135089a",
  null
  
)

export default component.exports